import { Session } from "react-router-dom";
import { API } from "../core/config";
import client from "../core/http/client";
import { ApiResponse } from "../shared/types/api";
import { Device } from "../models/device";

class SecurityApi {
    // Change Password
    async initChangePassword(data: { current_password: string; new_password: string; confirm_password: string }): Promise<ApiResponse<{ challenge_id: string }>> {
        const response = await client.post<ApiResponse<{ challenge_id: string }>>(
            API.ACCOUNT.CHANGE_PASSWORD_INIT,
            data
        );
        return response.data;
    }

    async confirmChangePassword(data: { challenge_id: string; code: string }): Promise<ApiResponse<null>> {
        const response = await client.post<ApiResponse<null>>(
            API.ACCOUNT.CHANGE_PASSWORD_CONFIRM,
            data
        );
        return response.data;
    }

    // Sessions
    async getSessions(): Promise<ApiResponse<Session[]>> {
        // console.log('[SecurityApi] getSessions appelé');
        try {
            const response = await client.get<ApiResponse<Session[]>>(API.ACCOUNT.SESSIONS);
            // console.log('[SecurityApi] getSessions réponse :', response.data);
            return response.data;
        } catch (error) {
            // console.error('[SecurityApi] getSessions erreur :', error);
            throw error;
        }
    }


    async logoutSession(sessionId: string): Promise<ApiResponse<null>> {
        const response = await client.delete<ApiResponse<null>>(
            `${API.ACCOUNT.SESSIONS}/${sessionId}`
        );
        return response.data;
    }

    async logoutAllSessions(): Promise<ApiResponse<null>> {
        const response = await client.delete<ApiResponse<null>>(API.ACCOUNT.SESSIONS);
        return response.data;
    }

    // Devices
    async getDevices(): Promise<ApiResponse<Device[]>> {
        // console.log('[SecurityApi] getDevices appelé');
        try {
            const response = await client.get<ApiResponse<Device[]>>(API.ACCOUNT.DEVICES);
            // console.log('[SecurityApi] getDevices réponse :', response.data);
            return response.data;
        } catch (error) {
            // console.error('[SecurityApi] getDevices erreur :', error);
            throw error;
        }
    }

    async deleteDevice(deviceId: string): Promise<ApiResponse<null>> {
        const response = await client.delete<ApiResponse<null>>(
            `${API.ACCOUNT.DEVICES}/${deviceId}`
        );
        return response.data;
    }
}

export const securityApi = new SecurityApi();